<template>
  <Suggestions
    :suggestions="visibleSuggestions"
    @add="addSuggestion"
    @reject="rejectSuggestion"
  />
</template>

<script>
import Suggestions from '@@/advertisement/common/Suggestions';
import shuffleArray from '@/utils/shuffleArray';

import { AdBid } from '@/api/api';

import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'BidsSuggestions',
  components: {
    Suggestions,
  },
  mixins: [campaignId],
  data() {
    return {
      suggestions: [],
    };
  },
  computed: {
    visibleSuggestions() {
      return shuffleArray(this.suggestions).slice(0, 3);
    },
  },
  created() {
    this.getSuggestions();
  },
  methods: {
    getSuggestions() {
      return AdBid.getSuggestions(this.campaignId)
        .then(suggestions => {
          this.suggestions = suggestions;
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
    addSuggestion(suggestion) {
      this.$emit('add', suggestion);
    },
    rejectSuggestion(suggestion) {
      return AdBid.rejectSuggestion({
        suggestion,
        campaignId: this.campaignId,
      })
        .then(message => {
          this.$message.success(message);

          this.removeSuggestion(suggestion);
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
    removeSuggestion(suggestion) {
      this.suggestions = this.suggestions.filter(sugg => sugg !== suggestion);
    },
  },
};
</script>
